import React, {useEffect} from 'react';
import { Modal } from 'antd';
import { useModal } from '../../contexts/ModalContext';
import withTranslation from "../WithTranslation/WithTranslation";

const CustomModal = ({ t }) => {
  const { isModalVisible, modalData, closeModal } = useModal();

  useEffect(() => {

  }, [modalData]);

  const { data } = modalData || {};

  return (
    <Modal
      title={t('Thank_you_for_your_order')}
      open={isModalVisible}
      onCancel={closeModal}
      footer={null}
    >
      {data ? (
        data.vendor === 'bank_transfer' ? (
          // 🟡 TPay content
          <React.Fragment>
            <p>{t('Hello')}, {data.name}</p>
            <p>{t('Thank_your_for_order_waiting')}</p>
            <p>{t('Our_bank_connections')}</p>

            <p style={{ fontWeight: 'bold' }}>{t('Liderstal_Wojciech_Bieniek')}:</p>
            <ul>
              <li>{t('Bank')}: {t('PKO_BANK_POLSKI')}</li>
              <li>{t('Account_number')}: {t('Account_number_number')}</li>
              {process.env.REACT_APP_LOCALE !== 'de' && process.env.REACT_APP_LOCALE !== 'at' && (
                <li>
                  {t('Sort_code')} ({t('Foreign_countries_only')}): {t('sort_code_number_1020')}
                </li>
              )}
              <li>IBAN: {t('iban_number')}</li>
              <li>BIC: {t('BPKOPLPW')}</li>
            </ul>

            <p style={{ fontWeight: 'bold' }}>[{t('Order_no')} {data.order_id}] ({data.date})</p>

            <table>
              <tbody>
              <tr>
                <td style={{fontWeight: 'bold', paddingRight: '50px'}}>{t('Form_of_payment')}:</td>
                <td>{t('Bank_transfer')}</td>
              </tr>
              <tr>
                <td style={{fontWeight: 'bold', paddingRight: '50px'}}>{t('Subtotal')}:</td>
                <td>{data.garage_price} {data.currency}</td>
              </tr>
              <tr>
                <td style={{fontWeight: 'bold', paddingRight: '50px'}}>{t('Transportation')}:</td>
                <td>{data.transport_price} {data.currency}</td>
              </tr>
              <tr>
                <td style={{fontWeight: 'bold', paddingRight: '50px'}}>{t('Total_price')}:</td>
                <td>{data.garage_price + data.transport_price} {data.currency}</td>
              </tr>
              <tr>
                <td style={{fontWeight: 'bold', paddingRight: '50px'}}>{t('Transfer_price')}:</td>
                <td>{data.price_to_pay} PLN</td>
              </tr>
              </tbody>
            </table>

            <table style={{marginTop: '10px'}}>
              <tbody>
              <tr>
                <td style={{fontWeight: 'bold'}}>{t('Billing_address')}</td>
                <td style={{ fontWeight: 'bold' }}>{t('Delivery_address')}</td>
              </tr>
              <tr>
                <td style={{ paddingRight: '50px' }}>
                  <div style={{ display: 'flex', flexFlow: 'column' }}>
                    <span>{data.name}</span>
                    <span>{data.address}</span>
                    <span>{data.postal_code} {data.city}</span>
                    <span>{data.phone}</span>
                    <span>{data.email}</span>
                  </div>
                </td>
                <td>
                  <div style={{display: 'flex', flexFlow: 'column'}}>
                    <span>{data.name}</span>
                    <span>{data.address}</span>
                    <span>{data.postal_code} {data.city}</span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </React.Fragment>
        ) : data.vendor === 'klarna' ? (
          // 🔵 Klarna content
          <React.Fragment>
            <p>{t('Payment_with_klarna_successful')}</p>
          </React.Fragment>
        ) : (
          // 🟠 Unknown vendor fallback
          <p>{t('Hello')}, {t('Customer')}</p>
        )
      ) : (
        // 🔴 No data at all
        <p>{t('Hello')}, {t('Customer')}</p>
      )}
    </Modal>
  );
};

export default withTranslation(CustomModal);
